<template>
  <section id="clients-list" class="padded">
     <transition name="slide-fade">
      <div class="grid c-4" v-if="sectionLoaded">
          <div v-for="(client, index) in clients[currentLang].clients" :key="'client'+index">
            <h2>{{client.name}}</h2>
            <div v-html="client.description"></div>
          </div>
        </div>
      </transition>
    </section>
</template>

<script>
import scrollBehavior  from '@/mixins/scrollBehavior.js'

export default {
	mixins: [scrollBehavior],
	props: ['clients', 'site', 'currentLang'],
  data(){
    return {
      sectionLoaded: false,
    }
  },
  watch:{
    visible(visible){
      if(visible){
        this.sectionLoaded = true;
      }
    }
  },
}
</script>

<style lang="scss">
	#clients-list{
      padding-top: 5em!important;
      line-height: 1.2;
      min-height:50vh;
      @media screen and (max-width: 768px){
        .grid.c-3{
          grid-gap: 2em;
          grid-template-columns: repeat(1, 1fr);
        }
      }
       @media screen and (min-width: 768px) and (max-width: 1024px){
        .grid.c-3{
          grid-gap: 2em;
          grid-template-columns: repeat(2, 1fr);
        }
      }
      h2{
        margin-bottom:.2em;
        font-family: 'surtSemiBold_extended';
        letter-spacing: 0.86px;
        color: #272727;
        font-size: 1.7rem;
      }
      h2 + div > p{
        font-size: 0.9333rem;
        color:rgba(39,39,39, .5);
        max-width:375px;
        line-height:1.4;
      }
    }
  
</style>
